module.exports = __webpack_public_path__ + "static/media/3.87b9caa3.JPG";